import React from 'react';
import { connect } from 'react-redux';
import { Grid, GridColumn, GridRow } from 'semantic-ui-react';

import { AppState } from 'services/types';
import Bold from 'components/Bold';
import { SprayEventStartDate } from 'services/sprayEvents/types';
import { createStructuredSelector } from 'reselect';
import {
    WorksheetPageIndex,
    SprayWorksheetEarliestHarvestDate
} from 'services/worksheet/types';
import {
    makeSelectSprayWorksheetOperatorFullName,
    makeSelectFormattedSprayWorksheetDate,
    makeSelectSprayWorksheetEntities,
    makeSelectSprayWorksheetEarliestHarvestDate
} from './selectors';
import { selectIsWeedSprayWorksheet } from '../../selectors';

export interface OwnProps {
    pageIndex: WorksheetPageIndex;
}

interface ConnectedProps {
    date: SprayEventStartDate;
    operatorFullName: string | undefined;
    entities: string;
    earliestHarvestDate: SprayWorksheetEarliestHarvestDate;
    isWeedSpray: ReturnType<typeof selectIsWeedSprayWorksheet>;
}

type Props = OwnProps & ConnectedProps;

export class PrintSprayWorksheetHeaderComponent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const {
            date,
            operatorFullName,
            entities,
            earliestHarvestDate,
            isWeedSpray
        } = this.props;

        return (
            <Grid columns="2" className="print-worksheet-header">
                <GridRow className="print-worksheet-header-title">
                    <GridColumn>
                        <h3 className="title">
                            {isWeedSpray ? 'Weed' : 'Crop'} Spray Applicator
                            Worksheet
                        </h3>
                    </GridColumn>
                    <GridColumn textAlign="right">
                        <span className="organisation">T&G Global</span>
                    </GridColumn>
                </GridRow>
                <GridRow className="print-worksheet-header-content">
                    <GridColumn>
                        <Bold>Applicator:</Bold> <span>{operatorFullName}</span>
                    </GridColumn>
                    <GridColumn textAlign="right">
                        <Bold>Handling Precautions:</Bold>{' '}
                        <span>
                            Full PPE - Gloves, Boots, Spray-suit, Respirator
                        </span>
                    </GridColumn>
                </GridRow>
                <GridRow className="print-worksheet-header-content">
                    <GridColumn>
                        <Bold>Orchards:</Bold> <span>{entities}</span>
                    </GridColumn>
                    <GridColumn textAlign="right">
                        <Bold>Date:</Bold> <span>{date}</span>
                    </GridColumn>
                </GridRow>
                <GridRow className="print-worksheet-header-content">
                    <GridColumn width="16" textAlign="right">
                        <Bold>Earliest harvest date:</Bold>{' '}
                        <span>{earliestHarvestDate}</span>
                    </GridColumn>
                </GridRow>
            </Grid>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    date: makeSelectFormattedSprayWorksheetDate(),
    operatorFullName: makeSelectSprayWorksheetOperatorFullName(),
    entities: makeSelectSprayWorksheetEntities(),
    earliestHarvestDate: makeSelectSprayWorksheetEarliestHarvestDate(),
    isWeedSpray: selectIsWeedSprayWorksheet
});

export default connect(mapStateToProps)(PrintSprayWorksheetHeaderComponent);
